import { styled } from "@mui/system";
import { Box, List, ListItem, TextField, IconButton } from "@mui/material";

export const VenueStepContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  minHeight: "300px",
  padding: '0 16px',
  width: "100%",
  boxSizing: "border-box",
  flexGrow: 1,
  justifyContent: "flex-start",
});

export const StyledList = styled(List)({
  width: "100%",
  backgroundColor: "rgba(118, 118, 128, 0.24)",
  maxHeight: "450px",
  overflow: "hidden",
  overflowY: "auto",
  paddingBottom: '0',
  paddingTop: '0'
});

export const StyledListItem = styled(ListItem)({
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  borderRadius: '10px 10px 0px 0px',
  borderBottom: '0.40px solid var(--Separators-Non-opaque---Dark, rgba(84, 84, 88, 0.65))',
  padding: '9px 16px',
  cursor: 'pointer',
  "&:hover": { // Corregido el selector
    backgroundColor: "rgba(84, 84, 88, 0.65)",
    borderRadius: '0',
  }
});

export const StyledIconButton = styled(IconButton)({
  display: 'flex',
  paddingRight: '16px',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '16px',
  "&:hover": { // Corregido el selector
    backgroundColor: "transparent",
  }
});

export const StyledSearchField = styled(TextField)({
  backgroundColor: "rgba(118, 118, 128, 0.24)",
  borderRadius: "10px",
  width: "100%",
  marginBottom: "10px",
  ".MuiOutlinedInput-root": {
    "& fieldset": {
      border: "none",
    },
    "& input": {
      color: "rgba(235, 235, 245, 0.7)",
      padding: "8px",
      paddingLeft: "20px", // To make space for the search icon
      fontSize: "17px",
      fontWeight: "400",
      lineHeight: '22px',
      letterSpacing: '-0.408px',
    },
  },
  ".MuiInputAdornment-root": {
    position: "absolute",
    left: "8px",
    color: "rgba(235, 235, 245, 0.7)",
  },
});
